import Repo from './Repo.js'

export default class RealLocationRepository extends Repo {
  constructor () {
    super('real-locations')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id) {
    return super.get(id)
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
    return super.paginate(q)
  }
}
